import React from "react";
import { FC } from "react";
import { css } from "styled-components";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import GridContainer, { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemStyle } from "@insite/mobius/GridItem";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import translate from "@insite/client-framework/Translate";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import HPPRegisterIcon from "@NA/Icons/HPPRegisterIcon";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect, useSelector } from "react-redux";
import { StyledButton } from "@insite/mobius/Clickable";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";


const enum fields {
    title = "title",
    contentTitle = "contentTitle",
    contentDescription = "contentDescription",
    getStartedBtn = "getStartedBtn",
    getStartedBtnUrl = "getStartedBtnUrl",

}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.title]: string;
        [fields.contentTitle]: string;
        [fields.contentDescription]: string;
        [fields.getStartedBtn]: string;
        [fields.getStartedBtnUrl]: string;

    };
}

const mapStateToProps = (state: CustomApplicationState) => {
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    return {
        isAuthenticated: state.context.session.isAuthenticated,
        isMylistAccess: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess || adiUserRoles.administrator,
    };
};
type Props = OwnProps & ReturnType<typeof mapStateToProps>;

interface ADIHPProjectRegistrationStyles {
    HPPGridContainer?: InjectableCss;
    HPPGridCard?: InjectableCss;
    HPPTwoColGridCard: InjectableCss;
    HPPTitleCardContainer?: InjectableCss;
    HPPTitle?: InjectableCss;
    HPPContentCardContainer?: InjectableCss;
    HPPContentTitle?: InjectableCss;
    HPPContentDescription?: InjectableCss;
    HPPBtnStyle?: InjectableCss;
    HPPBtnGriditem?: InjectableCss;
    HPPTwoColBtnGriditem?: InjectableCss;
    HPPContentGridItem?: InjectableCss;
    HPPTittleGridItem?: InjectableCss;
    HPPContentGridContainer?: InjectableCss;
}

const ADIHPProjectRegistrationStyles: ADIHPProjectRegistrationStyles = {

    HPPGridContainer: {
        css: css`
            margin:0 auto;
            padding: 15px 0;
            gap:20px;
            display:flex;
            flex: 1;
            height: 100%;
            position: relative;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction:column;
                    `,
                    css`
                        flex-direction:column;
                    `,
                    null,
                    null,
                    null,
                ])}
                ${GridWrapper} {
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            css`
                                max-width:100%;
                            `,
                            null,
                            null,
                        ])}
                }  
        `,
    },
    HPPGridCard: {
        css: css`
        flex:1;
        min-height:388px;
        border-radius: 6px;
        background-color: #fff;
        ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`min-height:auto;`,
            css`min-height:auto;`,
            css`min-height:auto;`,
            null,
            null,
        ])}  
        > ${GridOffset} {
         width:100%;
         margin:0px;
         height: 100%;
        }
    `,
    },
    HPPTwoColGridCard: {
        css: css`
        flex:1;
        min-height:285px;
        border-radius: 6px;
        background-color: #fff;
        ${({ theme }) =>
        breakpointMediaQueries(theme, [
            css`min-height:auto;`,
            css`min-height:auto;`,
            css`min-height:auto;`,
            null,
            null,
        ])}  
        > ${GridOffset} {
         width:100%;
         margin:0px;
         height: 100%;
        }
    `,
    },
    HPPTitleCardContainer: {
        css: css`
        border-radius: 6px;
        border-bottom-left-radius:0px;
        border-bottom-right-radius:0px;
        padding: 15px 20px !important;
        background-color: #006892;
        width:100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        > svg {
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width:28px;
                        height:28px;
                    `,
                    css`
                        width:28px;
                        height:28px;
                    `,
                    null,
                    null,
                    null,
                ])}
        }
    `,
    },
    HPPTitle: {
        css: css`
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        color: #fff;
        margin-left:10px;
        ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size: 16px;
                `,
                    css`
                    font-size: 16px;
                `,
                css`
                    font-size: 18px;
                `,
                    null,
                    null,
                ])}
    `,
    },
    HPPContentCardContainer: {
        css: css`
        padding:15px 20px 20px;
        height:calc(100% - 65px);
        border-radius: 6px;
        border: solid 1px #bbb;
        border-top-left-radius:0px;
        border-top-right-radius:0px;
        border-top:none;
        display: flex;
        flex-direction: column;
        justify-content:flex-start;
        align-items: flex-start;
        width: 100%;
        margin: 0 auto;
    `,
    },
    HPPContentGridContainer: {
        css: css`
        > ${GridOffset} {
         width:100%;
         margin:0px;
         height: 100%;
         display: flex;
        flex-direction: column;
            ${GridItemStyle}{
                max-width: 100%;
                width:100%;
                padding: 0px;
                flex-basis:initial;
                flex-direction: column;
            }
        }   
    `,
    },
    HPPTittleGridItem: {
        css: css`
               
    `,
    },
    HPPContentTitle: {
        css: css`
        font-size: 20px;
        font-weight: bold;
        line-height: normal;
        color: #2d2926;
        margin-bottom:10px;
        display: block;
         ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size: 16px;
                `,
                    css`
                    font-size: 16px;
                `,
                css`
                    font-size: 18px;
                `,
                    null,
                    null,
                ])}
    `,
    },
    HPPContentDescription: {
        css: css`
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: #2d2926;
        margin-bottom:10px;
        display: block;
    `,
    },
    HPPContentGridItem: {
        css: css`           
        flex:1 !important;
    `,
    },
    HPPBtnGriditem: {
        css: css`    
        display: flex;
        width:100%;
    `,
    },
    HPPBtnStyle: {
        css: css`
        padding: 10px;
        border-radius: 4px;
        border: solid 1px #004da6;
        background-color: #fff;
        min-height: 40px;
        line-height: 1;
        width: calc(100% - 40px);
        margin: 0 20px 20px;
        position: absolute;
        left: 0;
        bottom: 16px;

        ${({ theme }) => { return breakpointMediaQueries(
            theme, [null, null, 
            css` width: 100%; 
                 margin: 0;
                 bottom: 0;
                 position: relative;
                 margin-top: 20px;`
            ,],"max",); 
        }}

        &:hover {
                background-color: #c8ddf6;
        }
        > ${TypographyStyle} {
            color: #004da6;
            font-size: 16px;
            font-weight: bold;
            width: 100%;
            text-align: center;
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    font-size: 14px;
                `,
                    css`
                    font-size: 14px;
                 `,
                 css`
                    font-size: 14px;
                 `,
                    null,
                    null,
                    null,
                ])}
            
        }
    `,
    },
    HPPTwoColBtnGriditem: {
        css: css`
        display: flex;
        width:100%;
        ${StyledButton}{ {
            left: auto;
            right: 0;
            max-width: 210px;
            ${({ theme }) => { return breakpointMediaQueries(
                theme, [null, null, css` max-width: 100%; `,],"max",); 
            }}
        }
    `,
    },
};

const styles = ADIHPProjectRegistrationStyles;

const ADIHPProjectRegistration: FC<Props> = ({ fields, isAuthenticated, isMylistAccess }) => {
    const userRoles = useSelector((state: CustomApplicationState) => state.context.session.userRoles);
    const isProRewardsUser = userRoles && userRoles.includes("ADIProRewards");
    return (
        <>
            {isAuthenticated &&
                <StyledWrapper {...styles.HPPGridContainer}>
                    <GridContainer {...(!isMylistAccess && !isProRewardsUser ? styles.HPPTwoColGridCard : styles.HPPGridCard)}>
                        <GridItem width={[12]} {...styles.HPPTitleCardContainer}>
                            <HPPRegisterIcon />
                            <Typography {...styles.HPPTitle}>{fields.title}</Typography>
                        </GridItem>
                        <GridItem width={[12]} {...styles.HPPContentCardContainer}>
                            <GridContainer {...styles.HPPContentGridContainer}>
                                <GridItem {...styles.HPPTittleGridItem}>
                                    <Typography {...styles.HPPContentTitle}>{fields.contentTitle}</Typography>
                                    <Typography {...styles.HPPContentDescription}>{fields.contentDescription}</Typography>
                                </GridItem>
                                <GridItem {...styles.HPPContentGridItem}>
                                </GridItem>
                                <GridItem {...(!isMylistAccess && !isProRewardsUser ? styles.HPPTwoColBtnGriditem : styles.HPPBtnGriditem)}>
                                    <Link href={fields.getStartedBtnUrl} {...styles.HPPBtnStyle}>
                                        {translate(fields.getStartedBtn)}
                                    </Link>
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </StyledWrapper>
            }
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps) (ADIHPProjectRegistration),
    definition: {
        group: "Common",
        displayName: "ADI Project Registration",
        fieldDefinitions: [
            {
                name: fields.title,
                editorTemplate: "TextField",
                defaultValue: "Project Registration",
                fieldType: "General",
            },
            {
                name: fields.contentTitle,
                editorTemplate: "TextField",
                defaultValue: "Register a Project and Lock in Savings",
                fieldType: "General",
            },
            {
                name: fields.contentDescription,
                editorTemplate: "TextField",
                defaultValue: "When you use our free Project Registration service, our team will work directly with suppliers to get you the best possible pricing.",
                fieldType: "General",
            },
            {
                name: fields.getStartedBtn,
                editorTemplate: "TextField",
                defaultValue: "Get Started",
                fieldType: "General",
            },
            {
                name: fields.getStartedBtnUrl,
                editorTemplate: "TextField",
                defaultValue: "",
                fieldType: "General",
            },


        ],
    },
};

export default widgetModule;
